module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAABGCAYAAADb7SQ4AAAArklEQVRoge3ZK5LCYBCF0ZNfw3JmFzzWAnaQxMJiwLMAshoeOiMmkRRVVEjM/XRXH9Ouq7bRt8QGP5gZtgeuOOAMVQfv8Tsw9qoau6ptLHAaCe1bFWxHRmFTtY0b5iPD9zIBCvMyAQoCBw4cOHDgwIEDBw4cOHDgwIEDBw4cOHDgwIEDBw78KXyfwH0UNG/Hhu9acJwAPhb/3/J6RLTGqT+uHda44PkF7NntXnWWP6GgHfoF5MeEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-yellow.png
// module id = 28
// module chunks = 0